import { useState } from 'react';
import { useDeleteWorkOrderCharge } from '@api/enterprise/workorder';
import type { WorkOrderCharge } from '../types/charges.types';

export const useChargesDeletion = (jobNumber: string) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [chargeToDelete, setChargeToDelete] = useState<WorkOrderCharge | null>(
    null
  );

  const closeModal = () => {
    setIsDeleteModalOpen(false);
    setChargeToDelete(null);
  };

  const { mutate: deleteCharge, isPending: isDeleting } =
    useDeleteWorkOrderCharge();

  const handleDeleteCharge = (charge: WorkOrderCharge) => {
    setChargeToDelete(charge);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = () => {
    if (!chargeToDelete?.sequenceNumber) {
      return;
    }

    closeModal();

    deleteCharge({
      jobNumber,
      sequenceNumber: chargeToDelete.sequenceNumber
    });
  };

  const handleCloseModal = () => {
    if (!isDeleting) {
      closeModal();
    }
  };

  return {
    isDeleteModalOpen,
    chargeToDelete,
    isDeleting,
    handleDeleteCharge,
    handleConfirmDelete,
    handleCloseModal
  };
};
